module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/onboarding/components/create-user-page/create-user-page.component.scss
// module id = ./src/app/onboarding/components/create-user-page/create-user-page.component.scss
// module chunks = main